export enum FeatureFlagModelDataTypes {
    Array = 'array',
    Boolean = 'boolean',
    String = 'string',
}

export type FeatureFlagModelData<TType extends FeatureFlagModelDataTypes> =
    TType extends FeatureFlagModelDataTypes.Boolean
        ? Record<string, never>
        : TType extends FeatureFlagModelDataTypes.Array
          ? { value: Array<string> }
          : { value: string };

type FeatureFlagBase = {
    availableInFrontend: boolean;
    description: string;
    enabled: boolean;
    id: string;
};

export type FeatureFlag<TType extends FeatureFlagModelDataTypes | undefined = undefined> =
    TType extends FeatureFlagModelDataTypes
        ? FeatureFlagBase & {
              data: FeatureFlagModelData<TType>;
              type: TType;
          }
        :
              | (FeatureFlagBase & {
                    data: FeatureFlagModelData<FeatureFlagModelDataTypes.Array>;
                    type: FeatureFlagModelDataTypes.Array;
                })
              | (FeatureFlagBase & {
                    data: FeatureFlagModelData<FeatureFlagModelDataTypes.Boolean>;
                    type: FeatureFlagModelDataTypes.Boolean;
                })
              | (FeatureFlagBase & {
                    data: FeatureFlagModelData<FeatureFlagModelDataTypes.String>;
                    type: FeatureFlagModelDataTypes.String;
                });

export type FeatureFlagBaseLog = {
    id: string;
    practitionerId: string;
};

export type FeatureFlagLog = Pick<FeatureFlag, 'id'> &
    Pick<FeatureFlagBaseLog, 'practitionerId'> &
    Partial<Omit<FeatureFlag, 'id'>>;

export type FeatureFlagUpdate = Omit<FeatureFlag, 'id'> & Partial<Omit<FeatureFlag, 'id'>>;

export type FeatureFlagCreate = FeatureFlag;
